///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.gsmd = abcsetup.dashboard.gsmd || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.gsmd = {
    init: function () {
        // New item in process - delete button clicked
        $(document).on('click', '#app_data_tables_front_store_item_item_data_tablein_process .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/front_store/' + _this.data('id')).then(response => {
                        window.location.reload();
                    });
                }
            });
        });

        // New item in process - delete button clicked
        $(document).on('click', '#app_data_tables_rx_item_item_data_tablein_process .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/rx_item/' + _this.data('id')).then(response => {
                        window.location.reload();
                    });
                }
            });
        });

        $(document).on('click', '.lirBtn', function(e) {
            let action = $(this).data('action');
            let task = $(this).data('task');
            let table = $('.lirBtn').closest('table').attr('id');

            abcsetup.alerts.confirm(
                action === 'approve' ? 'Approve' + ' item name change?' : 'Reject' + ' item name change?',
                "Are you sure you want to " + action + " this item?",
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);
                        axios.post('/like_item_renaming/update_workflow', {
                            'id': task,
                            'action': action
                        }).then(response => {                            
                            if (response.data && response.data.message) {
                                window.LaravelDataTables[table].ajax.reload();
                                /* Reload the Library table */
                                window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_library_data_table"].ajax.reload();

                                let count = Number($('#lir_count').val());
                                if (count == 1) {
                                    $('#lir_badge').addClass('d-none');
                                    $('#lir_count').val(0);
                                } else {
                                    let newCount = Number(count - 1);
                                    $('#lir_badge').html("&nbsp;" + newCount.toString() + "&nbsp;");
                                    $('#lir_count').val(newCount);
                                }
                            }

                            abcsetup.unblockUI();
                        }).catch(error => {
                            console.error(error);
                        });
                    }
                },
                action == 'approve' ? 'Approve' : 'Reject',
                action == 'approve' ? 'btn btn-success' : 'btn btn-danger'
            );
        });

        /* LIR Batch Actions */
        let selectedIds = [];

        $(document).on('click', '.lir-batch-box', function(e) {
            $('.lir-batch-box:checked').length > 0
                ? $('.batch-buttons').removeClass('d-none')
                : $('.batch-buttons').addClass('d-none');
  
            /* Handles storing the data-id of each LIRItem we want to bacth action. */
            $(this).is(':checked') ? selectedIds.push($(this).data('id')) : selectedIds.splice(selectedIds.indexOf($(this).data('id')), 1);
        });

        $(document).on('click', '.lir-rx-select-all-btn', function(e) {
            $('.rx-batch-btn').each(function() {
                $(this).click();
            });
        });

        $(document).on('click', '.lir-consumer-select-all-btn', function(e) {
            $('.consumer-batch-btn').each(function() {
                $(this).click();
            });
        });

        $(document).on('click', '.lir-batch-option', function(e) {
            let action = $(this).data('action');

            abcsetup.alerts.confirm(
                'Bulk Action',
                "Are you sure you want to bulk "+ action + " these " + selectedIds.length + " items?",
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);
                        axios.post('/like_item_renaming/batch_update_items', {
                            'items': selectedIds,
                            'action': action
                        }).then(response => {                            
                            if (response.data && response.data.message) {
                                window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_task_data_tableconsumer"].ajax.reload();
                                window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_task_data_tablerx"].ajax.reload();
                                /* Reload the Library table */
                                window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_library_data_table"].ajax.reload();

                                let count = Number($('#lir_count').val());
                                if (count == selectedIds.length) {
                                    $('#lir_badge').addClass('d-none');
                                    $('#lir_count').val(0);
                                } else {
                                    let newCount = Number(count - selectedIds.length);
                                    $('#lir_badge').html("&nbsp;" + newCount.toString() + "&nbsp;");
                                    $('#lir_count').val(newCount);
                                }
                            }

                            $('.batch-buttons').addClass('d-none');
                            selectedIds = [];
                            abcsetup.unblockUI();
                        }).catch(error => {
                            $('.batch-buttons').addClass('d-none');
                            abcsetup.unblockUI();
                            console.error(error);
                        });
                    }
                },
                action == 'approve' ? 'Approve' : 'Reject',
                action == 'approve' ? 'btn btn-success' : 'btn btn-danger'
            )
        });

        $(document).on('click', '#update-lir-item-btn', function(e) {
            let key = $(this).data('id');
            e.preventDefault();

            abcsetup.blockUI(true);

            let formData = {};

            $('.lir-modal-content-' + key).find('input, select').each(function() {
                formData[$(this).attr('name')] = $(this).val();
            });

            axios.patch('/like_item_renaming/'+ key, formData)
                .then(response => {
                    window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_task_data_tableconsumer"].ajax.reload();
                    window.LaravelDataTables["app_data_tables_l_i_r_l_i_r_task_data_tablerx"].ajax.reload();

                    abcsetup.unblockUI();
                })
                .catch(error => {
                    abcsetup.unblockUI();
                    console.error(error);

                    abcsetup.alerts.show("Something went wrong", "We could not update this LIR Item record at this time. Please try again later or reach out to support.");
                });
        });

        $(document).on('change keyup', function() {
            if ($('.invalid').length) {
                $('#update-lir-item-btn').attr('disabled', true);
            } else {
                $('#update-lir-item-btn').attr('disabled', false);
            }
        })
    },
}
